import React from "react";
import { Link } from "react-router-dom";
import aboutImg from "../assets/images/features/about-1.png"

import {FiCheckCircle, MdKeyboardArrowRight} from '../assets/icons/vander'

export default function AboutOne(){
    return(
        <>
        <div className="container relative md:mt-24 mt-16">
            <div className="grid md:grid-cols-2 grid-cols-1 items-center gap-6">
                <div className="relative overflow-hidden rounded-lg  ps-6 pt-6 lg:me-8">
                    <img src={aboutImg} className="ltr:rounded-tl-lg rtl:rounded-tr-lg" alt=""/>
                </div>

                <div className="">
                    <h3 className="mb-4 md:text-3xl md:leading-normal text-2xl leading-normal font-semibold">Discover AI Products with Ease</h3>
                    <p className="text-slate-400 max-w-xl">Find the best AI products, read genuine reviews, and make informed decisions on our marketplace. From productivity tools to enterprise platforms, explore a wide range of AI solutions tailored to your needs.</p>

                    <ul className="list-none text-slate-400 mt-4">
                        <li className="mb-2 flex items-center"><FiCheckCircle className="text-amber-400 h-5 w-5 me-2"/>Get insights from verified users to see how AI tools perform</li>
                        <li className="mb-2 flex items-center"><FiCheckCircle className="text-amber-400 h-5 w-5 me-2"/>Access detailed overviews, key features, compliance info and pricing</li>
                        <li className="mb-2 flex items-center"><FiCheckCircle className="text-amber-400 h-5 w-5 me-2"/>Find AI tools for businesses and everyday users with detailed search</li>
                    </ul>

                   
                </div>
            </div>
        </div>
        </>
    )
}